// extracted by mini-css-extract-plugin
export default {"filterBox":"MBFm2heCXGVeQKo+AshSvg=="};